export function millisecondsToHours(milliseconds: number): number {
    return milliseconds / 1000 / 60 / 60;
}

export function millisecondsToMinutes(milliseconds: number): number {
    return milliseconds / 1000 / 60;
}

export function hoursToMilliseconds(hours: number): number {
    return hours * 60 * 60 * 1000;
}

export function minutesToMilliseconds(minutes: number): number {
    return minutes * 60 * 1000;
}

export function secondsToMilliseconds(seconds: number): number {
    return seconds * 1000;
}

function hoursToMinutes(hours: number): number {
    return hours * 60;
}

export function toHoursAndMinutes(totHours: number): string {
    const totMinutes = hoursToMinutes(totHours);

    const hours = Math.floor(totHours);
    const minutes = Math.round(totMinutes % 60);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}
